import { render } from "./Heart.vue?vue&type=template&id=350c0a86&scoped=true&ts=true"
import script from "./Heart.vue?vue&type=script&lang=ts"
export * from "./Heart.vue?vue&type=script&lang=ts"

import "./Heart.vue?vue&type=style&index=0&id=350c0a86&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350c0a86"]])

export default __exports__